import React from "react";
export var clientComponents = {
    "client-calculator-rsx": React.lazy(function () { return import("../client/modules/calculator/calculator-rsx"); }),
};
